import { jsx as _jsx } from "react/jsx-runtime";
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { useSelector } from 'react-redux';
import { Locale } from 'signup-ui-lego-core/constants/Locale';
import { isOnIndustryStepAndCredentialVerifiedNewUser } from '../experiments/acq111/acq111Utils';
import { getIsGoogleCredentialAuthentication } from '../google-authentication/useGoogleCredentialForAuthentication';
import { useCurrentStep } from '../hooks/useCurrentStep';
import { getApplicationLocale } from '../i18n/LocaleUtils';
import { Data } from '../signup-data/DATA';
import { useSignupData } from '../signup-data/useSignupData';
import { getIsOAuthExistingUser } from '../store/app/selectors';
import { getPreviousStep } from '../store/flow/selectors';
import { Step } from '../views/Step';
import { StepSubtitle } from './StepSubtitle';
const STEPS_FOLLOWED_BY_PRETITLE = [Step.LandingPage, Step.ExistingAccounts];
export const GreetingsPretitle = ({
  preTitleMessage
}) => {
  const {
    data: firstName
  } = useSignupData(Data.FirstName);
  const {
    data: lastName
  } = useSignupData(Data.LastName);
  const previousStep = useSelector(getPreviousStep);
  const locale = getApplicationLocale();
  const isJapanese = locale === Locale.ja;
  const {
    currentStep
  } = useCurrentStep();
  const isGoogleCredentialAuthentication = useSelector(getIsGoogleCredentialAuthentication);
  const isExistingOAuthUser = useSelector(getIsOAuthExistingUser);

  const renderNiceToMeetYouSubtitle = () => {
    return /*#__PURE__*/_jsx(StepSubtitle, {
      message: `views.nice-to-meet-you`,
      messageOptions: {
        name: isJapanese ? lastName : firstName
      }
    });
  };

  if (isOnIndustryStepAndCredentialVerifiedNewUser(currentStep, isGoogleCredentialAuthentication, isExistingOAuthUser)) {
    return renderNiceToMeetYouSubtitle();
  }

  if (preTitleMessage && isValidI18nKey(preTitleMessage) || !previousStep || !STEPS_FOLLOWED_BY_PRETITLE.includes(previousStep)) {
    return null;
  }

  if (previousStep === Step.ExistingAccounts) {
    return /*#__PURE__*/_jsx(StepSubtitle, {
      message: `views.hi`,
      messageOptions: {
        name: isJapanese ? lastName : firstName
      }
    });
  }

  return renderNiceToMeetYouSubtitle();
};